/**
 * @file 号码标记
 * @author wangzhuang
 */

import {rcAjax} from '../util';
import {
    GET_V1_CAPTCHA,
    GET_V1_REPORT,
    GET_REPORT_SUBMIT,
    MARK_UPDATE,
    GET_MARK_TYPE,
    // MARK_MSG_UPDATE,
    MARK_CLEAN,
    GET_MARK_TAG
} from './ActionTypes';

export function fetchMarkTag(dispatch) {
    return rcAjax('GET', '/api/v1/report/tags', {}, {}, (data = {}) => {
        dispatch({type: GET_MARK_TAG, data: data.data});
    });
}

export function fetchCaptcha(dispatch, params) {
    return rcAjax('POST', '/api/v1/captcha', {}, params, data => {
        dispatch({type: GET_V1_CAPTCHA, data: data.data});
    });
}
export function fetchReportSubmit(dispatch, params) {
    return rcAjax('POST', '/api/v1/report/submit', {}, params, data => {
        dispatch({type: GET_REPORT_SUBMIT, data: data.data});
    });
}

export function fetchReport(dispatch, params) {
    return rcAjax('POST', '/api/v1/report', {}, params, data => {
        dispatch({type: GET_V1_REPORT, data: data.data});
    });
}

export function fetchPhoneType(dispatch, params) {
    return rcAjax('POST', '/api/v1/appeal/search', {}, params, data => {
        dispatch({type: GET_MARK_TYPE, data: data.data});
    });
}

export function updateMark(dispatch, obj) {
    dispatch({
        type: MARK_UPDATE,
        data: obj
    });
    return obj;
}

export function cleanMark(dispatch) {
    dispatch({
        type: MARK_CLEAN
    });
}
// export function updateMarkMsg(dispatch, obj) {
//     dispatch({
//         type: MARK_MSG_UPDATE,
//         data: obj
//     });
//     return obj;
// }
